import { AdvisorForm } from '@/types/advisor';
import { endpoint } from './apiConstants';
import axios from '@/plugins/axios';

export const getSubmitAdvisorHistory = async () => {
    const res = await axios.get(endpoint.getAdvisorHistory);
    return res;
};

export const submitAdvisorHistory = async (form: AdvisorForm) => {
    const res = await axios.post(endpoint.submitAdvisorHistory, form);
    return res;
};